export default "__VITE_ASSET__d2a622de__"